import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Loader2, Lock } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If already logged in, redirect
    fetch(`${BACKEND_URL}/api/superadmin/auth/me`, { credentials: 'include' })
      .then(r => r.ok && navigate('/superadmin'))
      .catch(() => {});
  }, [navigate]);

  const handleLogin = async () => {
    if (!email || !password) { toast.error('Compila tutti i campi'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/superadmin/auth/login`, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Accesso negato');
      }
      toast.success('Accesso super admin effettuato');
      navigate('/superadmin');
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-navy p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-yellow rounded-lg mb-4">
            <Shield className="w-9 h-9 text-brand-navy" strokeWidth={2} />
          </div>
          <h1 className="font-heading text-3xl font-light text-white">Accesso Amministratore</h1>
          <p className="text-white/60 text-sm mt-2">Area riservata</p>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-lg space-y-5">
          <div className="flex items-center gap-2 text-primary">
            <Lock className="w-5 h-5" />
            <span className="font-medium">Autenticazione Sicura</span>
          </div>
          
          <div><Label>Email</Label><Input type="email" className="h-12" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="sa-email" placeholder="admin@example.com" /></div>
          <div><Label>Password</Label><Input type="password" className="h-12" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="sa-password" onKeyDown={(e) => e.key === 'Enter' && handleLogin()} /></div>
          
          <Button onClick={handleLogin} disabled={loading} className="w-full h-12 bg-brand-navy hover:bg-slate-800 text-brand-yellow font-medium" data-testid="sa-login-submit">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Verifica...</> : 'Accedi'}
          </Button>

          <a href="/login" className="block text-center text-sm text-muted-foreground hover:text-primary">
            ← Login utente normale
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
